import React, { FC } from "react";
import { Link } from "react-router-dom";

interface Props {
  href?: string;
}

const ButtonSubmit: FC<Props> = ({ href = "/listing-stay-map" }) => {
  return (
    <Link
      to={href}
      type="button"
      className="h-8 md:h-12 w-8 md:w-12 rounded-full bg-sky-400 hover:bg-primary-400 flex items-center justify-center text-neutral-50 focus:outline-none"
    >
      {/*<span className="mr-3 md:hidden">Search</span>*/}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="xl:h-5 xl:w-5 lg:h-5 lg:w-5 h-4 w-4 "
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        />
      </svg>
    </Link>
  );
};

export default ButtonSubmit;
